export const state = () => ({
  loading: false,
  inquiries: null,
  inquiriesMeta: null,
});

export const mutations = {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_INQUIRIES(state, payload) {
    state.inquiries = payload;
  },
  SET_INQUIRIES_META(state, payload) {
    state.inquiriesMeta = payload;
  },
};

export const actions = {
  restoreInitialState({ commit }) {
    commit('SET_INQUIRIES', []);
  },
  async getOwnerConnectInquiries({ commit }, page) {
    try {
      commit('SET_LOADING', true);
      let { data } = await this.$http.get('/api/owner_connect/get_shortlist', {
        params: {
          page: page,
        },
      });
      commit('SET_INQUIRIES', data.data.data);
      commit('SET_INQUIRIES_META', data.data.meta);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async toggleOwnerConnectInquiry({ commit }, listingId) {
    try {
      commit('SET_LOADING', true);
      let { data } = await this.$http.post('/api/owner_connect/set_shortlist', {
        id: listingId,
      });
      console.log('SET INQUIRIES', data);
    } finally {
      commit('SET_LOADING', false);
    }
  },
};
